// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1CO1d","calendarButtons":"ClockData_calendarButtons__3RlsW"};